import { useRef as i } from "react";
import { useIsoMorphicEffect as u } from './use-iso-morphic-effect.js';
function s(n, t) {
  var e = i({
    left: 0,
    top: 0
  });
  if (u(function () {
    if (!t) return;
    var r = t.getBoundingClientRect();
    r && (e.current = r);
  }, [n, t]), t == null || !n || t === document.activeElement) return !1;
  var o = t.getBoundingClientRect();
  return o.top !== e.current.top || o.left !== e.current.left;
}
export { s as useDidElementMove };